const hasWholeProductAttribute = (attr) =>
    attr?.productAttribute != null
    && typeof attr.productAttribute === 'object'
    && attr.productAttribute.type != null;

const attrKey = (attr) => {
    if (attr?.productAttribute?.id != null) return `pa:${attr.productAttribute.id}`;
    return null;
};

function mergeLineAttributes(localAttrs, backAttrs) {
    if (!Array.isArray(localAttrs) || localAttrs.length === 0) return backAttrs;
    if (!Array.isArray(backAttrs)) return localAttrs;

    const backByKey = new Map();
    backAttrs.forEach((attr) => {
        const key = attrKey(attr);
        if (key !== null && !backByKey.has(key)) backByKey.set(key, attr);
    });

    const canMatchById = backByKey.size > 0;

    const merged = localAttrs.map((localAttr, index) => {
        const key = attrKey(localAttr);
        const backAttr = canMatchById ? backByKey.get(key) : backAttrs[index];
        if (backAttr === undefined) return localAttr;

        if (hasWholeProductAttribute(backAttr)) {
            return {
                ...localAttr,
                ...backAttr,
                productAttribute: backAttr.productAttribute ?? localAttr.productAttribute,
            };
        }

        return {
            ...localAttr,
            value: backAttr.value ?? localAttr.value,
        };
    });

    const localKeys = new Set(localAttrs.map(attrKey).filter(key => key !== null));
    const backOnlyAttrs = backAttrs.filter((attr) => {
        const key = attrKey(attr);
        return key !== null && !localKeys.has(key);
    });

    return [...merged, ...backOnlyAttrs];
}

export function mergeRecalculatedQuoteLines(localLines, backLines) {
    if (!Array.isArray(backLines) || !Array.isArray(localLines)) return backLines;

    return backLines.map((backLine, index) => {
        const localLine = localLines[index];
        const localAttrs = localLine?.quoteLineInfo?.quoteLineInfoProductAttributes;
        if (!Array.isArray(localAttrs) || localAttrs.length === 0) return backLine;

        const backAttrs = backLine?.quoteLineInfo?.quoteLineInfoProductAttributes;

        return {
            ...backLine,
            quoteLineInfo: {
                ...localLine.quoteLineInfo,
                ...backLine.quoteLineInfo,
                product: backLine?.quoteLineInfo?.product ?? localLine?.quoteLineInfo?.product,
                quoteLineInfoProductAttributes: mergeLineAttributes(localAttrs, backAttrs),
            },
        };
    });
}
